import store from '@/store';
import { calcDate } from "@/util/date.js";
export default {
    height: "auto",
    calcHeight: 30,
    tip: false,
    searchShow: true,
    searchSpan: 6,
    searchMenuSpan: 6,
    border: true,
    index: true,
    viewBtn: false,
    editBtn: false,
    delBtn: false,
    addBtn: false,
    selection: false,
    dialogClickModal: false,
    searchLabelWidth: 100,
    column: [{
            label: "主键id",
            prop: "id",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "进件编号",
            prop: "businessCode",
            type: "input",
            search: true,
            searchOrder: 995,
            minWidth:140,
        },
        {
            label: "所属代理商",
            prop: "businessDeptName",
            type: "input",
            minWidth: 120,
        },
        {
            label: "产品类型",
            prop: "rentType",
            type: "select",
            minWidth: 120,
            dicData: store.getters.porductTypes
        },
        {
            label: "产品类型",
            prop: "rentTypeList",
            type: "select",
            hide: true,
            search: true,
            searchOrder: 999,
            searchMultiple: true,
            dicData: store.getters.porductTypes,
            minWidth: 120,
        },
        {
            label: "租赁人",
            prop: "name",
            type: "input",
            search: true,
            minWidth: 100,
            searchOrder: 998,
        },
        {
            label: "手机号",
            prop: "phoneNumber",
            type: "input",
            minWidth: 120,
        },
        {
            label: "车牌号",
            prop: "carFirstNumber",
            type: "input",
            search: true,
            searchOrder: 997,
            minWidth: 100,
        },
        {
            label: "车辆品牌",
            prop: "carBrand",
            type: "input",
            minWidth: 100,
        },
        {
            label: "逾期天数",
            prop: "delayDays",
            type: "input",
            minWidth: 80,
        },
        {
            label: "催收人",
            prop: "collectorUserName",
            type: "input",
            minWidth: 100,
            formatter: (val, value) => {
              return value || '没有催收过';
            },
        },
        {
            label: "催收时间",
            minWidth: 100,
            prop: "collectorCreateTime",
            type: "input",
            formatter: (val, value) => {
              return value || '没有催收过';
            },
        },
        // {
        //   label: '车库',
        //   prop: 'carPosition',
        //   type: 'input',
        //   hide: true,
        //   formatter: (val, value) => {
        //     return value || '-';
        //   },
        // },
        // {
        //   label: '拖车位置',
        //   prop: 'trailerLocation',
        //   type: 'input',
        //   hide: true,
        //   formatter: (val, value) => {
        //     return value || '-';
        //   },
        // },
        // {
        //   label: '距离',
        //   prop: 'distance',
        //   type: 'input',
        //   hide: true,
        //   formatter: (val, value) => {
        //     return value || '-';
        //   },
        // },
        {
            label: "所属代理商",
            prop: "businessDeptIdList",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: true,
            searchClearable: true,
            defaultExpandAll: true,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "title",
                value: "id",
            },
        },
        // {
        //   label: "类型",
        //   prop: "actionSourceType",
        //   type: "select",
        //   hide: true,
        //   showColumn: false,
        //   search: true,
        //   dicData: [
        //     {
        //       label: "逾期未还",
        //       value: 1
        //     },
        //     {
        //       label: "合同违约",
        //       value: 2
        //     },
        //     {
        //       label: "其他",
        //       value: 99
        //     }
        //   ]
        // },
        // {
        //   label: "类型",
        //   prop: "actionSourceTypeList",
        //   type: "select",
        //   dataType: "number",
        //   dicData: [
        //     {
        //       label: "逾期未还",
        //       value: 1
        //     },
        //     {
        //       label: "合同违约",
        //       value: 2
        //     },
        //     {
        //       label: "其他",
        //       value: 99
        //     }
        //   ]
        // },
        // {
        //     label: "拖车类型",
        //     prop: "type",
        //     type: "select",
        //     // search: true,
        //     // searchOrder: 555,
        //     dicData: [{
        //             label: "待拖车",
        //             value: 1
        //         },
        //         {
        //             label: "未拖回",
        //             value: 2
        //         },
        //         {
        //             label: "已拖回",
        //             value: 3
        //         }
        //     ],
        // },
        // {
        //     label: "还租日期",
        //     prop: "currentLendingDate",
        //     type: "date",
        //     hide: true,
        //     // search: true,
        //     searchRange: true,
        //     searchType: "daterange",
        //     valueFormat: "yyyy-MM-dd",
        // },

        {
            label: "滞留时间",
            hide: false,
            prop: "delayTime",
            type: "input",
            minWidth: 120,
            formatter: (val, value, label) => {
                if (!value) return ''
                const date = calcDate(new Date(value).getTime(), new Date().getTime());
                return `${date.days}天${date.hours}小时${date.minutes}分`;
            }
        },
        {
            label: "耗时",
            prop: "timeConsuming",
            hide: true,
        },
        // {
        //     label: "谈判状态",
        //     hide: true,
        //     prop: "negotiationType",
        //     type: "input",
        // }
    ]
};
